import GroupSummary from 'src/containers/groups/registration/groupSummary';
import { GroupsRegistrationComponent } from 'src/assets/styles/components/groupsRegistration';
import { StepCard } from '../styles';
import StepProgress from './StepProgress';

const GroupSummaryStep = ({ groupInputs, onRestart }) => (
  <StepCard>
    <GroupsRegistrationComponent className="embedded">
      <StepProgress currentStepId="selectGroup" />
      <h1>¡Nos alegra que ya estés conectado!</h1>
      <GroupSummary match={{ params: {} }} inputs={groupInputs} onRestart={onRestart} />
    </GroupsRegistrationComponent>
  </StepCard>
);

export default GroupSummaryStep;
